import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Document } from 'src/app/shared/document';


@Component({
  selector: 'app-edit-document-row-info',
  templateUrl: './edit-document-row-info.component.html',
  styleUrls: ['./edit-document-row-info.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class EditDocumentRowInfoComponent implements OnInit, OnChanges, OnDestroy {

  @Input() document: Document;

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** EditDocumentConditionsComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** EditDocumentRowInfoComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //console.log('*** EditDocumentRowInfoComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

      switch (propName) {

        case 'document':
          if (change.currentValue) {
          }
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** EditDocumentRowInfoComponent in ngOnDestroy');

  }

  ngOnInit(): void {
    console.log('*** EditDocumentRowInfoComponent in ngOnInit');
  }

}

